// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"87":"fa437de7","409":"635368d5"}[chunkId] + ".chunk.js";
};